import { Component, OnInit } from '@angular/core';
import { ProposalService } from 'src/app/services/proposal-service';
import { StorageMap } from '@ngx-pwa/local-storage';
import { Subscription } from 'rxjs';
import { Proposal } from 'src/app/entities/proposal';

@Component({
  selector: 'app-report-total-proposals',
  templateUrl: './report-total-proposals.component.html',
  styleUrls: ['./report-total-proposals.component.css']
})
export class ReportTotalProposalsComponent implements OnInit {

  constructor(private storage: StorageMap, private proposalService: ProposalService) { }

  openSpaceId: number;
  dataSubscription: Subscription;
  totalProposals = 0;

  ngOnInit(): void {
    this.dataSubscription = this.storage.watch('selectedOpenId', { type: 'string' })
    .subscribe((openId) => {
      const openIdInt = parseInt(openId, 10);
      if (!isNaN(openIdInt)){
        this.openSpaceId = openIdInt;
        this.getOpenSpaceProposals(this.openSpaceId);
      }
    });

  }

  getOpenSpaceProposals(openSpaceId: number){
    this.proposalService.getOpenSpaceProposals(openSpaceId).subscribe(
      data => {
        if (data)
        {
          this.totalProposals = JSON.parse(data).Proposals.length;
        }
      },
      error => {
        console.error(error);
      }
    );
  }

}
